export const ANALYTICS_DATA_CREATED = 'processData';

export default {
    ANALYTICS_DATA_CREATED
};
